<template>
  <div class="iframe-wrapper">
    <Button type="primary" class="new-page-btn" size="small" @click="openNewPage" v-if="canOpenNewPage">新页面打开</Button>
    <iframe id="iframe" :src="iframeUrl"></iframe>
  </div>
</template>

<script>
import util from '../lib/util.ts'
import ajax from '../lib/ajax.ts'
import requestUrls from '@/lib/requestUrls'

export default {
  data() {
    return {
      iframeUrl: '',
      username: '',
      // roles: '',
      department: '',
      canOpenNewPage: false
    }
  },
  async mounted() {
    if (!this.$store.state.session.user) {
      await this.$store.dispatch({
        type: 'session/init'
      })
    }
    this.username = this.$store.state.session.user.name
    if (this.$store.state.session.listOrg.length > 0) {
      this.department = this.$store.state.session.listOrg[0].displayName
    }
    this.switchUrl(this.$route.name)
  },
  watch: {
    '$route'(to) {
      this.switchUrl(to.name)
    }
  },
  computed: {
    roles() {
      return this.getRoles(this.$store.state.session.roleNames)
    }
  },
  methods: {
    openNewPage() {
      window.open(this.iframeUrl)
    },
    async switchUrl(name) {
      this.canOpenNewPage = false
      let switchName = name.split('(i)')[0]
      switch (switchName) {
        case 'attence':
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/人力模块/attendance.cpt&op=write&&name=${this.username}`
          break
        case 'mailpwd':
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/修改个人密码/企业邮箱密码.cpt&op=write&name=${this.username}`
          break
        case 'oapwd':
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/修改个人密码/修改OA密码.cpt&op=write&name=${this.username}`
          break
        case 'tbgl':
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B6295%5D%5B6807%5D%5B7ba1%5D%5B7406%5D%2F%5B6295%5D%5B6807%5D%5B7ba1%5D%5B7406%5D.cpt&username=${this.username}&department=${this.department}`
          break
        case 'pxgl':
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B57f9%5D%5B8bad%5D%5B7ba1%5D%5B7406%5D%2F%5B57f9%5D%5B8bad%5D%5B7ba1%5D%5B7406%5D.cpt&name=${this.username}`
          break
        case 'kbrl':
        case 'kbrl2':
          this.canOpenNewPage = true
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B4f1a%5D%5B8bae%5D%5B5ba4%5D%5B5b89%5D%5B6392%5D%2FKaiBiaoPlan.cpt`
          break
        case 'withdrawn':
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2FAbp%5B79bb%5D%5B804c%5D%5B7528%5D%5B6237%5D%2FAbpUser.cpt`
          break
        case 'endingProject':
          this.canOpenNewPage = true
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2FGD%2FProject%2Fmain.cpt&userName=${this.username}&userId=${this.$store.state.session.user.id}`
          break
        case 'biddingExamine':
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B4e2d%5D%5B6807%5D%5B901a%5D%5B77e5%5D%5B4e66%5D%5B5ba1%5D%5B6838%5D%2F%5B4e2d%5D%5B6807%5D%5B901a%5D%5B77e5%5D%5B4e66%5D%5B5ba1%5D%5B6838%5D%5B60c5%5D%5B51b5%5D%5B8868%5D.cpt`
          break
        case 'yjyl':
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B5e94%5D%5B6536%5D%5B6b3e%5D%2Fyingshoukuan2.cpt&UserName=${this.username}`
          break
        case 'MendProjectAuditFq':
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B7ed3%5D%5B9879%5D%5B5ba1%5D%5B6838%5D%2F%5B7ed3%5D%5B9879%5D%5B5ba1%5D%5B6838%5D%28%5B53d1%5D%5B8d77%5D%5B4eba%5D%5B5ba1%5D%5B6838%5D%29.cpt&user=${this.username}`
          break
        case 'MendProjectAuditJx':
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B7ed3%5D%5B9879%5D%5B5ba1%5D%5B6838%5D%2F%5B7ed3%5D%5B9879%5D%5B5ba1%5D%5B6838%5D%28%5B7ed3%5D%5B9879%5D%5B4eba%5D%5B5458%5D%5B5ba1%5D%5B6838%5D%29.cpt&user=${this.username}`
          break
        case 'MendProjectAuditJc':
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B7ed3%5D%5B9879%5D%5B5ba1%5D%5B6838%5D%2F%5B7ed3%5D%5B9879%5D%5B5ba1%5D%5B6838%5D%28%5B76d1%5D%5B5bdf%5D%5B4eba%5D%5B5458%5D%5B5ba1%5D%5B6838%5D%29.cpt&user=${this.username}`
          break
      }
    },
    getRoles(rolesObj = []) {
      let roles = ''
      rolesObj.forEach((role) => {
        roles += `,${role}`
      })
      roles = roles.slice(1)
      return roles
    }
  }
}
</script>

<style lang="less" scoped>
.iframe-wrapper {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  #iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
  .new-page-btn {
    position: absolute;
    right: 150px;
    top: 2px;
  }
}
</style>
